// Imports: local files.
import {
  GET_ALL_FORMAL_EDUCATION_RESOURCES_START,
  GET_ALL_FORMAL_EDUCATION_RESOURCES_SUCCESS,
  GET_ALL_FORMAL_EDUCATION_RESOURCES_FAILED,
  GET_ALL_FORMAL_EDUCATION_RESOURCES_RESET,
  GET_ONE_FORMAL_EDUCATION_RESOURCE_START,
  GET_ONE_FORMAL_EDUCATION_RESOURCE_SUCCESS,
  GET_ONE_FORMAL_EDUCATION_RESOURCE_FAILED,
  GET_ONE_FORMAL_EDUCATION_RESOURCE_RESET,
  CREATE_FORMAL_EDUCATION_RESOURCE_START,
  CREATE_FORMAL_EDUCATION_RESOURCE_SUCCESS,
  CREATE_FORMAL_EDUCATION_RESOURCE_FAILED,
  CREATE_FORMAL_EDUCATION_RESOURCE_RESET,
  UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_START,
  UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_SUCCESS,
  UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_FAILED,
  UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_RESET,
  DELETE_ONE_FORMAL_EDUCATION_RESOURCE_START,
  DELETE_ONE_FORMAL_EDUCATION_RESOURCE_SUCCESS,
  DELETE_ONE_FORMAL_EDUCATION_RESOURCE_FAILED,
  DELETE_ONE_FORMAL_EDUCATION_RESOURCE_RESET,
  UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_START,
  UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_SUCCESS,
  UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_FAILED,
  UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_RESET,
  PIN_FORMAL_EDUCATION_RESOURCE_START,
  PIN_FORMAL_EDUCATION_RESOURCE_SUCCESS,
  PIN_FORMAL_EDUCATION_RESOURCE_FAILED,
  PIN_FORMAL_EDUCATION_RESOURCE_RESET,
  UNPIN_FORMAL_EDUCATION_RESOURCE_START,
  UNPIN_FORMAL_EDUCATION_RESOURCE_SUCCESS,
  UNPIN_FORMAL_EDUCATION_RESOURCE_FAILED,
  UNPIN_FORMAL_EDUCATION_RESOURCE_RESET,
} from '../actions/formalEducationResources.actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};

const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  create: initialLoadingState,
  update: initialLoadingState,
  delete: initialLoadingState,
  uploadPhoto: initialLoadingState,
  pin: initialLoadingState,
  unpin: initialLoadingState,
};

const formalEducationResourcesReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All Formal Education Resources
     * =======================================================================
     */
    case GET_ALL_FORMAL_EDUCATION_RESOURCES_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_FORMAL_EDUCATION_RESOURCES_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_FORMAL_EDUCATION_RESOURCES_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_FORMAL_EDUCATION_RESOURCES_RESET:
      return { ...state, getAll: { ...initialLoadingState } };

    /**
     * =======================================================================
     * Get One Formal Education Resource
     * =======================================================================
     */
    case GET_ONE_FORMAL_EDUCATION_RESOURCE_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_FORMAL_EDUCATION_RESOURCE_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_FORMAL_EDUCATION_RESOURCE_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_FORMAL_EDUCATION_RESOURCE_RESET:
      return { ...state, getOne: { ...initialLoadingState } };

    /**
     * =======================================================================
     * Create New Formal Education Resource
     * =======================================================================
     */
    case CREATE_FORMAL_EDUCATION_RESOURCE_START:
      return { ...state, create: { ...action.payload } };
    case CREATE_FORMAL_EDUCATION_RESOURCE_SUCCESS:
      return { ...state, create: { ...action.payload } };
    case CREATE_FORMAL_EDUCATION_RESOURCE_FAILED:
      return { ...state, create: { ...action.payload } };
    case CREATE_FORMAL_EDUCATION_RESOURCE_RESET:
      return { ...state, create: { ...initialLoadingState } };

    /**
     * =======================================================================
     * Update One Formal Education Resource
     * =======================================================================
     */
    case UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_START:
      return { ...state, update: { ...action.payload } };
    case UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_SUCCESS:
      return { ...state, update: { ...action.payload } };
    case UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_FAILED:
      return { ...state, update: { ...action.payload } };
    case UPDATE_ONE_FORMAL_EDUCATION_RESOURCE_RESET:
      return { ...state, update: { ...initialLoadingState } };

    /**
     * =======================================================================
     * Delete One Formal Education Resource
     * =======================================================================
     */
    case DELETE_ONE_FORMAL_EDUCATION_RESOURCE_START:
      return { ...state, delete: { ...action.payload } };
    case DELETE_ONE_FORMAL_EDUCATION_RESOURCE_SUCCESS:
      return { ...state, delete: { ...action.payload } };
    case DELETE_ONE_FORMAL_EDUCATION_RESOURCE_FAILED:
      return { ...state, delete: { ...action.payload } };
    case DELETE_ONE_FORMAL_EDUCATION_RESOURCE_RESET:
      return { ...state, delete: { ...initialLoadingState } };

    /**
     * =======================================================================
     * Upload Photo Formal Education Resource
     * =======================================================================
     */
    case UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_START:
      return { ...state, uploadPhoto: { ...action.payload } };
    case UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_SUCCESS:
      return { ...state, uploadPhoto: { ...action.payload } };
    case UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_FAILED:
      return { ...state, uploadPhoto: { ...action.payload } };
    case UPLOAD_PHOTO_FORMAL_EDUCATION_RESOURCE_RESET:
      return { ...state, uploadPhoto: { ...initialLoadingState } };

    /**
     * =======================================================================
     * Pin Formal Education Resource
     * =======================================================================
     */
    case PIN_FORMAL_EDUCATION_RESOURCE_START:
      return { ...state, pin: { ...action.payload } };
    case PIN_FORMAL_EDUCATION_RESOURCE_SUCCESS:
      return { ...state, pin: { ...action.payload } };
    case PIN_FORMAL_EDUCATION_RESOURCE_FAILED:
      return { ...state, pin: { ...action.payload } };
    case PIN_FORMAL_EDUCATION_RESOURCE_RESET:
      return { ...state, pin: { ...initialLoadingState } };

    /**
     * =======================================================================
     * Unpin Formal Education Resource
     * =======================================================================
     */
    case UNPIN_FORMAL_EDUCATION_RESOURCE_START:
      return { ...state, unpin: { ...action.payload } };
    case UNPIN_FORMAL_EDUCATION_RESOURCE_SUCCESS:
      return { ...state, unpin: { ...action.payload } };
    case UNPIN_FORMAL_EDUCATION_RESOURCE_FAILED:
      return { ...state, unpin: { ...action.payload } };
    case UNPIN_FORMAL_EDUCATION_RESOURCE_RESET:
      return { ...state, unpin: { ...initialLoadingState } };

    default:
      return state;
  }
};

export default formalEducationResourcesReducer;
